import type {
CoreProductResponseList,
  ParameterID,
} from '@flecto/types'

import { api } from '../../../services/api'

export type GetAllProductOptions = {
  q?: string
  limit?: number
  offset?: number
  order?: 'asc' | 'desc'
  sort?: 'id' | 'title' | 'price_cents' | 'booking_cost_cents' | 'created_at'
  autocomplete?: boolean
  category_ids?: ParameterID[]
  start_at?: string
  end_at?: string
  quantity?: number
}

/**
 * Get all products from a store.
 *
 * @endpoint GET /api/stores/{storeDomain}/products
 * @scope store
 * @see https://flecto.dev/api-4724247
 */
export async function getAllProducts(
  storeDomain: string,
  options?: GetAllProductOptions
): Promise<CoreProductResponseList> {
  const response = await api.get<CoreProductResponseList>(
    `/api/stores/${storeDomain}/products`,
    {
      params: options,
    }
  )
  return response.data
}
